import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-search',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M17.5 17.5 22 22" />
      <path stroke="currentColor" stroke-linejoin="round" stroke-width="2"
            d="M20 11c0-4.97056-4.0294-9-9-9-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9 4.9706 0 9-4.0294 9-9Z" />
    </svg>
  `
})
export class IconSearchComponent {
  size: InputSignal<number> = input<number>(24);
}
